
import React, { Component } from 'react';

export default class CancelIcon extends Component {

    render(){
        const fillStyle = {fill:this.props.fillColor}
        return (
            <svg width="100%" height="100%" viewBox="0 0 80 80" style={this.props.svgStyle}>
              <g style={fillStyle}>
                <path d="M34.326,39.978l-18.2,-18.199c-0.646,-0.69 -0.761,-0.976 -0.947,-1.508c-0.849,-2.425 0.843,-5.272 3.84,-5.32c0.085,0.004 0.17,0.008 0.256,0.012c0.929,0.105 1.536,0.248 2.508,1.159l18.2,18.199l18.199,-18.199c0.813,-0.762 1.866,-1.186 3.021,-1.167c1.988,0.159 2.169,0.666 2.725,1.259c1.425,1.519 1.569,3.797 -0.089,5.565l-18.199,18.199l18.199,18.2c2.708,2.887 -1.503,9.552 -5.657,5.657l-18.199,-18.2l-18.2,18.2c-1.581,1.483 -2.112,1.211 -3.021,1.167c-2.948,-0.142 -4.942,-4.214 -2.811,-6.637c0.056,-0.064 0.117,-0.125 0.175,-0.187l18.2,-18.2Z" />
              </g>
            </svg>
        )
    }
}
